import { client } from '../../../../Apollo';
import { GetRefusedBudgetReasons } from '../query/GetRefusedBudgetReasons';

const getReasons = () => new Promise((resolve, reject) => {
  client
    .query({
      query: GetRefusedBudgetReasons,
      fetchPolicy: 'network-only',
    })
    .then((r) => {
      resolve(r.data.ReparofoneGetRefusedBudgetReasons);
    })
    .catch((e) => {
      console.log(e.message, 'erro ao buscar');
      reject(e.message);
    });
});

export default getReasons;
